import React from 'react';
import { TokenInfo } from '../types';

interface ChainProps {
    chains: string[];
    selected: string;
    onSelect: (c: string) => void;
}

export function ChainSelector({ chains, selected, onSelect }: ChainProps) {
    return (
        <div className="selector">
            <label>Chain</label>
            <select value={selected} onChange={(e) => onSelect(e.target.value)}>
                {chains.map((c) => (
                    <option key={c} value={c}>
                        {c}
                    </option>
                ))}
            </select>
        </div>
    );
}

interface TokenProps {
    coins: TokenInfo[];
    selected: TokenInfo | null;
    onSelect: (t: TokenInfo) => void;
}

export function TokenSelector({ coins, selected, onSelect }: TokenProps) {
    return (
        <div className="token-list">
            {coins.map((c) => (
                <button
                    key={c.address}
                    className={
                        selected?.address.toLowerCase() === c.address.toLowerCase()
                            ? 'token-btn selected'
                            : 'token-btn'
                    }
                    onClick={() => onSelect(c)}
                >
                    <div className="symbol">{c.symbol}</div>
                    <div className="addr">{c.address.slice(0, 10)}…</div>
                </button>
            ))}
        </div>
    );
}
